import { Component, OnInit, Input } from '@angular/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';

import { FileUploadService } from '../services/file-upload.service';
import { ZpDataService } from '../services/zp-data.service';
import { UserInfoService } from '../services/user-info.service';
import { IUser } from '../models/user.model';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Input() public itemId;
  @Input() public readOnly: boolean;
  @Input() public planId;
  @Input() public view;
  public message: string;
  public subscription: Subscription;
  public myUser: IUser;
  public user:IUser;
  public attachments: [];
  public dataIsLoaded:boolean;
  isVisible: boolean;

  constructor(private zpDataService: ZpDataService, private userInfoService: UserInfoService, public themeService: ThemeService) {
    this.dataIsLoaded = true;
  }

  updateScreen() {
    this.zpDataService.getUser().then(async user => {
      this.user = user;
    });
    this.zpDataService.retrieveFileNames(this.itemId).then(attachments => this.attachments = attachments );
  }

  ngOnInit() {
    this.subscription = this.userInfoService.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });
    this.updateScreen()
    if (this.readOnly) {
      this.isVisible = true;
    } else {
      this.isVisible = false
    }
  }

  async fileUpload(element) {
    this.dataIsLoaded = false;
    const result = await this.zpDataService.uploadFile(element.target.files[0], this.itemId);
    this.dataIsLoaded = true;
    if(result.success) {
      this.attachments = await this.zpDataService.retrieveFileNames(this.itemId);
    } else {
      this.message = 'Sorry, your file could not be uploaded.'
    }
  }
}


